import styled from "styled-components";
import colors from "assets/styles/colors";

export default styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    min-height: 25px;
    max-height: 25px;
    min-width: 25px;
    max-width: 25px;

    border-radius: 5px;

    margin: 0 10px;

    user-select: none;
    cursor: pointer;

    .icon {
        font-size: 15px;
    }

    &.text-only {
        min-width: fit-content;
        max-width: fit-content;
        padding: 0 8px;
        margin: 0;

        .label {
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 0.05em;
            white-space: nowrap;
        }
    }

    &.primary {
        background-color: ${(props) => props.theme.primaryButtonBackground};

        .icon, .label {
            color: ${(props) => props.theme.primaryButtonForeground};
        }
        :hover {
            background-color: ${(props) =>
                props.theme.primaryButtonBackgroundHover};
        }
    }

    &.secondary {
        background-color: ${(props) => props.theme.secondaryButtonBackground};

        .icon, .label {
            color: ${(props) => props.theme.secondaryButtonForeground};
        }
        :hover {
            background-color: ${(props) =>
                props.theme.secondaryButtonBackgroundHover};
        }
    }

    &.third {
        background-color: ${(props) => props.theme.thirdButtonBackground};

        .icon, .label {
            color: ${(props) => props.theme.thirdButtonForeground};
        }
        :hover {
            background-color: ${(props) =>
                props.theme.thirdButtonBackgroundHover};
        }
    }

    &.accent {
        background-color: ${(props) => props.theme.accentButtonBackground};

        .icon, .label {
            color: ${(props) => props.theme.accentButtonForeground};
        }
        :hover {
            background-color: ${(props) =>
                props.theme.accentButtonBackgroundHover};
        }
    }

    &.flat {
        background-color: ${(props) => props.theme.flatButtonBackground};

        .icon, .label {
            color: ${(props) => props.theme.flatButtonForeground};
        }
        :hover {
            background-color: ${(props) =>
                props.theme.flatButtonBackgroundHover};
        }
    }

    &.disabled {
        background-color: ${(props) => props.theme.filterButtonBackground};
        cursor: auto;

        .icon {
            color: ${(props) => props.theme.filterButtonForeground};
        }
        :hover {
            background-color: ${(props) => props.theme.filterButtonBackground};
        }
    }
`;
